import React, { useState } from "react";
import InputSearch from "../../components/inputs/InputSearch";
import TableLeaderBoard from "../../components/Tables/TableLeaderBoard";
import { useGetUserLeaderboardQuery } from "../../services/users/leaderboard";
import Pagination from "../../components/Tables/Pagination";
import LoadingIndicator from "../../components/LoadingIndicator";
import EmptyState from "../../components/EmptyState";
import Icon from "../../components/icons/Icon";
import { UsersStrokeIcon } from "../../components/icons/Icons";
import { useTranslation } from "react-i18next";

const LeaderBoard = () => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(1);

  const {
    data: usersList,
    isLoading: isLeaderboardLoading,
    isFetching,
  } = useGetUserLeaderboardQuery({
    page,
    keyword: searchKeyword,
  });

  const { t } = useTranslation(["common", "leaderboard"]);

  const hasResults = usersList?.data?.length > 0;
  const isSearching = searchKeyword.trim().length > 0;

  if (isLeaderboardLoading && !usersList) return <LoadingIndicator />;

  return (
    <div className="container-fluid leaderboard-page">
      <div className="row justify-content-center p-4 ranks">
        <div className="col-lg-10 col-md-12">
          <div className="d-flex flex-wrap leaderboard-page__toolbar">
            <div className="mb-4 leaderboard-page__intro">
              <h1 className="mb-0 font_24 font-extrabold">
                {t("leaderboard:leaderboard")}
              </h1>
              <p className="mb-0 font_16 font-color-grey">
                {t("leaderboard:leaderboardDescription")}
              </p>
            </div>
            <div className="ms-auto mb-4 search-part">
              <InputSearch
                placeHolder={t("leaderboard:searchEmployeesPlaceholder")}
                value={searchKeyword}
                onChange={(e) => {
                  setSearchKeyword(e.target.value);
                  setPage(1);
                }}
              />
            </div>
          </div>

          {isFetching && !hasResults ? (
            <LoadingIndicator />
          ) : hasResults ? (
            <div className="table-white leaderboard-page__table-wrap">
              <TableLeaderBoard usersList={usersList} />
              <Pagination
                current={usersList?.pagination?.current}
                pages={usersList?.pagination?.pages}
                handlePagination={(nextPage) => setPage(nextPage)}
              />
            </div>
          ) : (
            <div className="leaderboard-page__empty">
              <EmptyState
                iconComponent={
                  <Icon
                    icon={<UsersStrokeIcon />}
                    iconName="users"
                    iconSize={38}
                    viewBox="0 0 25 25"
                    iconColor="#bbbabf"
                    hasStroke
                  />
                }
                title={
                  isSearching
                    ? t("leaderboard:noSearchResults")
                    : t("leaderboard:emptyLeaderboard")
                }
                emptyStateText={
                  isSearching
                    ? t("leaderboard:noSearchResultsHint")
                    : t("leaderboard:emptyLeaderboardHint")
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderBoard;
